// Vue imports
import Vue from 'vue/dist/vue.esm.js'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import VueCurrencyInput from 'vue-currency-input'
import VueConfirmDialog from 'vue-confirm-dialog'
import PrettyCheckbox from 'pretty-checkbox-vue';
import VueToast from 'vue-toast-notification';
import VModal from 'vue-js-modal/dist/index.nocss.js'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/de'

// Filters
import currencyFilter from '../filters/currency.js'
import floatFilter from '../filters/float.js'
import dateFilter from '../filters/date.js'
import dateTimeFilter from '../filters/date_time.js'

// Components
import accordion from '../components/accordion.vue'
import booleanLabel from '../components/boolean_label.vue'
import confirmButton from '../components/confirm_button.vue'
import deleteButton from '../components/delete_button.vue'
import deadlines from '../components/deadlines.vue'
import deadlineState from '../components/deadline_state.vue'
import dossiers from '../components/dossiers.vue'
import invoices from '../components/invoices.vue'
import invoicePayments from '../components/invoice_payments.vue'
import invoiceInvoicePayments from '../components/invoice_invoice_payments.vue'
import invoiceState from '../components/invoice_state.vue'
import sectionBox from '../components/section_box.vue'
import sectionEntry from '../components/section_entry.vue'
import trials from '../components/trials.vue'
import messages from '../components/messages.vue'
import messageForm from '../components/message_form.vue'
import messageEdit from '../components/message_edit.vue'
import messageDelete from '../components/message_delete.vue'

// Forms
import autokreditDossierForm from '../forms/autokredit_dossier.vue'
import deadlineForm from '../forms/deadline.vue'
import dieselDossierForm from '../forms/diesel_dossier.vue'
import fiatDossierForm from '../forms/fiat_dossier.vue'
import invoiceForm from '../forms/invoice/invoice.vue'
import invoiceItem from '../forms/invoice/invoice_item.vue'
import invoiceItemSection from '../forms/invoice/invoice_item_section.vue'
import invoiceFreeItemForm from '../forms/invoice/free_item_form.vue'
import invoiceRvgItemForm from '../forms/invoice/rvg_item_form.vue'
import invoicePaymentForm from '../forms/invoice/invoice_payment_form.vue'
import trialForm from '../forms/trial.vue'

// Modals
import deadlineEditFormModal from '../modals/deadline_edit_form.vue'
import deadlineCreateFormModal from '../modals/deadline_create_form.vue'
import trialEditFormModal from '../modals/trial_edit_form.vue'
import trialCreateFormModal from '../modals/trial_create_form.vue'

// Set up Vue globally
window.Vue = Vue;

// Use plugins
Vue.use(Vuex);
Vue.use(VueResource);
Vue.use(VueCurrencyInput);
Vue.use(VueConfirmDialog);
Vue.use(PrettyCheckbox);
Vue.use(VueToast);
Vue.use(VModal);
Vue.use(vSelect);

// Register filters
Vue.filter('toCurrency', currencyFilter.default);
Vue.filter('toFloat', floatFilter.default);
Vue.filter('toDate', dateFilter.default);
Vue.filter('toDateTime', dateTimeFilter.default);

// Register components
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
Vue.component('v-select', vSelect)
Vue.component('date-picker', DatePicker.default || DatePicker)
Vue.component('DatePicker', DatePicker.default || DatePicker) // Also register with PascalCase
Vue.component('mx-datepicker', DatePicker.default || DatePicker) // Try with mx-datepicker
Vue.component('Datepicker', DatePicker.default || DatePicker) // Try with Datepicker

Vue.component('accordion', accordion);
Vue.component('boolean-label', booleanLabel);
Vue.component('confirm-button', confirmButton);
Vue.component('delete-button', deleteButton);
Vue.component('deadlines', deadlines);
Vue.component('deadline-state', deadlineState);
Vue.component('dossiers', dossiers);
Vue.component('invoices', invoices);
Vue.component('invoice-payments', invoicePayments);
Vue.component('invoice-invoice-payments', invoiceInvoicePayments);
Vue.component('invoice-state', invoiceState);
Vue.component('section-box', sectionBox);
Vue.component('section-entry', sectionEntry);
Vue.component('trials', trials);
Vue.component('messages', messages);
Vue.component('message-form', messageForm);
Vue.component('message-edit', messageEdit);
Vue.component('message-delete', messageDelete);

Vue.component('autokredit-dossier-form', autokreditDossierForm);
Vue.component('deadline-form', deadlineForm);
Vue.component('diesel-dossier-form', dieselDossierForm);
Vue.component('fiat-dossier-form', fiatDossierForm);
Vue.component('invoice-form', invoiceForm);
Vue.component('invoice-item', invoiceItem);
Vue.component('invoice-item-section', invoiceItemSection);
Vue.component('invoice-free-item-form', invoiceFreeItemForm);
Vue.component('invoice-rvg-item-form', invoiceRvgItemForm);
Vue.component('invoice-payment-form', invoicePaymentForm);
Vue.component('trial-form', trialForm);

Vue.component('deadline-edit-form-modal', deadlineEditFormModal);
Vue.component('deadline-create-form-modal', deadlineCreateFormModal);
Vue.component('trial-edit-form-modal', trialEditFormModal);
Vue.component('trial-create-form-modal', trialCreateFormModal);

// Set up CSRF token
Vue.http.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

// Initialize Vue app
function initializeVue() {
  if (document.querySelector('#app') && !document.querySelector('#app').__vue__) {
    const app = new Vue({
      el: '#app',
      data: {
        message: 'Vue is working! 🎉'
      }
    })
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeVue)
} else {
  initializeVue()
}

